import { useState } from "react";
import {
  IconButton,
  Tooltip,
  Checkbox,
  Typography,
  Divider,
  Box,
  Card,
  Stack,
  ListItem,
  ListItemText,
  List,
  ListItemButton
} from "@mui/material";
import {
  Mail as MailIcon,
  ExpandMore as ExpandIcon,
  ExpandLess as CollapseIcon,
  Phone as PhoneIcon,
  Error as ErrorOutlineOutlinedIcon
} from "@mui/icons-material";
import { English } from "../../../constant/EnglishFallback";
import { useSelector } from "react-redux";
function YourInfoCard({ emails, phones, handleToggle, loginData, fromJob }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const { TEXT_YOUR_INFO = English.ResumeBuilder.TEXT_YOUR_INFO } = LanguageData || {};

  return (
    <Card className="pagelist-content" sx={{ p: 2 }}>
      <Box sx={{ alignItems: "center",  justifyContent: "space-between",  display: "flex" }}  >
        <Typography variant="h6">{TEXT_YOUR_INFO}</Typography>
        <IconButton color="primary" onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? <CollapseIcon /> : <ExpandIcon />}
        </IconButton>
      </Box>

      {isExpanded && (
        <UserInfoList
          emails={emails}
          phones={phones}
          handleToggle={handleToggle}
          loginData={loginData}
          fromJob={fromJob}
        />
      )}
    </Card>
  );
}

export default YourInfoCard;

export function UserInfoList({ emails, phones, handleToggle, loginData, fromJob }) {
  const fullName =
    loginData?.userInformation?.FirstName + " " + loginData?.userInformation?.LastName;

  return (
    <Stack spacing={1.5}>
      <Typography variant="h6">{fullName}</Typography>
      <ContactSection
        icon={<MailIcon color="primary" />}
        data={emails}
        renderItem={(email, index) => (
          <EmailList
            key={index}
            email={email}
            index={index}
            handleToggle={handleToggle}
            fromJob={fromJob}
          />
        )}
      />
      {/* Phone List */}
      {phones.length > 0 && (
        <Stack spacing={1.5}>
          <Divider />
          <ContactSection
            icon={<PhoneIcon color="primary" />}
            data={phones}
            renderItem={(num, index) => (
              <PhoneList key={index} num={num} index={index} handleToggle={handleToggle} />
            )}
          />
        </Stack>
      )}
    </Stack>
  );
}

function ContactSection({ icon, data, renderItem }) {
  return (
    <Stack spacing={1} direction={"row"}>
      <Box>{icon}</Box>
      <Box sx={{ width: "100%" }}>
        <List disablePadding>
          <Stack spacing={1}>{data.map((item, index) => renderItem(item, index))}</Stack>{" "}
        </List>
      </Box>
    </Stack>
  );
}

export function EmailList({ email, handleToggle, fromJob }) {
  if (email.emailType !== "Primary" && (!email.verified || email.verified === "")) return null;

  return (
    <Card className="pagelist-content" sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
      <ListItem
        alignItems="flex-start"
        secondaryAction={
          email.verified ? (
            <Checkbox
              edge="end"
              onChange={() => handleToggle(email.id, "EmailCard")}
              checked={email.isSelected}
            />
          ) : (
            <Tooltip title="Verify Email" placement="top">
              <IconButton>
                <ErrorOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )
        }>
        <ListItemText
          sx={{ m: 0, alignItems: "flex-start" }}
          primary={<Typography style={{ wordBreak: "break-word" }}>{email.email}</Typography>}
          secondary={getEmailTypeLabel(email.emailType)}
        />
      </ListItem>
    </Card>
  );
}

export function PhoneList({ num, handleToggle }) {
  const formatPhoneNumber = (phoneNo) => {
    const phoneString = phoneNo.toString();
    const firstThreeDigits = phoneString.slice(0, 3);
    const nextThreeDigits = phoneString.slice(3, 6);
    const remainingDigits = phoneString.slice(6);
    return `(${firstThreeDigits}) ${nextThreeDigits}-${remainingDigits}`;
  };

  return (
    <Card className="pagelist-content" sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
      <ListItem
        alignItems="flex-start"
        sx={{ m: 0, p: 0 }}
        secondaryAction={
          <Checkbox
            edge="end"
            onChange={() => handleToggle(num.id, "PhoneCard")}
            checked={num.isSelected}
          />
        }>
        <ListItemButton
          onClick={() => handleToggle(num.id, "PhoneCard")}
          alignItems="flex-start"
          sx={{ m: 0 }}>
          <ListItemText
            sx={{ m: 0, alignItems: "flex-start" }}
            primary={formatPhoneNumber(num.phoneNo)}
            secondary={getPhoneTypeLabel(num.phoneType)}
          />
        </ListItemButton>
      </ListItem>
    </Card>
  );
}

function getEmailTypeLabel(type) {
  switch (type) {
    case "Primary":
      return "Primary";
    case "P":
      return "Personal";
    case "W":
      return "Work";
    case "O":
      return "Other";
    default:
      return "";
  }
}

function getPhoneTypeLabel(type) {
  switch (type) {
    case "H":
      return "Home";
    case "M":
      return "Mobile";
    case "W":
      return "Work";
    case "O":
      return "Other";
    default:
      return "";
  }
}
